import * as zod from 'zod';

export type PrivatePensionSecondCopyFormData = {
  clientEmail: string;
  advisorEmail: string;
};

export const getDefaultValues = () => ({
  clientEmail: '',
  advisorEmail: '',
});

export type PrivatePensionSecondCopyData = ReturnType<typeof getDefaultValues>;

export const getValidationCreateSchema = () =>
  zod
    .object({
      clientEmail: zod.string(),
      advisorEmail: zod.string().optional(),
    })
    .refine((data) => !!data.clientEmail, {
      path: ['clientEmail'],
      message: 'O e-mail do cliente é obrigatório.',
    });
